import { LucideProps } from 'lucide-react'

const People = (props: LucideProps) => (
  <svg
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.7944 29.5889C29.9687 29.5889 36.5889 22.9617 36.5889 14.7944C36.5889 6.62718 29.9687 0 21.7944 0C13.6202 0 7 6.62022 7 14.7944C7 22.9687 13.6272 29.5889 21.7944 29.5889Z"
      fill="#DB4245"
    />
    <path
      d="M57.7124 29.5889C65.8866 29.5889 72.5068 22.9617 72.5068 14.7944C72.5068 6.62718 65.8797 0 57.7124 0C49.5451 0 42.918 6.62022 42.918 14.7944C42.918 22.9687 49.5382 29.5889 57.7124 29.5889Z"
      fill="#E3D9C9"
    />
    <path
      d="M36.5889 48.5505C36.5889 40.3763 29.9617 33.7561 21.7944 33.7561C13.6272 33.7561 7 40.3763 7 48.5505V80H36.5889V48.5505Z"
      fill="#DB4245"
    />
    <path
      d="M72.5068 48.5505C72.5068 40.3763 65.8797 33.7561 57.7124 33.7561C49.5451 33.7561 42.918 40.3833 42.918 48.5505V80H72.5068V48.5505Z"
      fill="#E3D9C9"
    />
  </svg>
)

export default People
